export const data = [
  {
    rollno: "#234",
    studentName: "John Doe",
    subject: "Maths",
    classLevel: "Primary",
    attendance: "25/30",
    firstTerm: "85/100", // Corrected spelling
    midTerm: "90/100",
    overallScore: "85/100",
  },
  {
    rollno: "#323",
    studentName: "Emma Watson",
    subject: "Physics",
    classLevel: "Secondary",
    attendance: "15/30",
    firstTerm: "65/100",
    midTerm: "10/100",
    overallScore: "85/100",
  },
  {
    rollno: "#434",
    studentName: "Sophia Williams",
    subject: "Biology",
    classLevel: "Higher Secondary",
    attendance: "25/30",
    firstTerm: "85/100",
    midTerm: "90/100",
    overallScore: "85/100",
  },
  {
    rollno: "#123",
    studentName: "Liam Williams",
    subject: "Physics",
    classLevel: "Secondary",
    attendance: "25/30",
    firstTerm: "85/100",
    midTerm: "90/100",
    overallScore: "85/100",
  },
  {
    rollno: "#421",
    studentName: "Olivia Martinez",
    subject: "English",
    classLevel: "Primary",
    attendance: "25/30",
    firstTerm: "85/100", // Corrected spelling
    midTerm: "90/100",
    overallScore: "85/100",
  },
  {
    rollno: "#124",
    studentName: "Charlotte Garcia",
    subject: "English",
    classLevel: "Secondary",
    attendance: "15/30",
    firstTerm: "65/100",
    midTerm: "10/100",
    overallScore: "85/100",
  },
  {
    rollno: "#676",
    studentName: "Mia Lee",
    subject: "Statistics",
    classLevel: "Higher Secondary",
    attendance: "25/30",
    firstTerm: "85/100",
    midTerm: "90/100",
    overallScore: "85/100",
  },
  {
    rollno: "#323",
    studentName: "Amelia Brown",
    subject: "Statistics",
    classLevel: "Secondary",
    attendance: "25/30",
    firstTerm: "85/100",
    midTerm: "90/100",
    overallScore: "85/100",
  },
];

export const headingsGrades = [
  "StudentName",
  "Attendance",
  "ExamTitle",
  "OverAllScore",
  "Attempt",
  "Remark",
  "More",
];
export const listResult = [
  {
    studentName: "John Doe",
    examType: "McQs",
    examTitle: "OOP",
    overallScore: "85/100",
    attempt: "2/2",
    remark: "-",
  },
  {
    studentName: "Emma Watson",
    examType: "Question",
    examTitle: "DSA",
    overallScore: "85/100",
    attempt: "2/2",
    remark: "-",
    overallScore: "85/100",
  },

];

export const headings = [
  "Subject Name",
  "Exam Title",
  "Class/Level",
  "Attendance",
  "OverallScore",
  "Action",
];
export const attendanceTableHeadings = [
  "Student Name",
  "Section",
  "Mark Attendance",
  "Overall Performance",
  "Action",
];

export const attendaceData = [
  {
    name: "eneh mercy",
    dp: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHJhbmRvbSUyMHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D",
    section: "Gold",
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "john doe",
    dp: null,
    section: "Silver",
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "Joyce",
    section: "Gold",
    dp: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fHww",
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "Thomas",
    section: "Silver",
    dp: null,
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "Eruka",
    section: "Gold",
    dp: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHJhbmRvbSUyMHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D",
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "Kuranai",
    dp: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHJhbmRvbSUyMHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D",
    section: "Silver",
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "Kakashi",
    section: "Gold",
    dp: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHJhbmRvbSUyMHBlb3BsZXxlbnwwfHwwfHx8MA%3D%3D",
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
  {
    name: "Sauske",
    section: "Gold",
    dp: null,
    attendance: [
      { label: "PP", checked: false },
      { label: "PO", checked: false },
      { label: "A", checked: false },
      { label: "L", checked: false },
    ],
    performance: "80%",
  },
];

export const feesHeadings = [
  "Entrollment No",
  "Due Date",
  "Amount Paid",
  "Discount",
  "Total Fees",
  "Status",
  "Action",
];
export const feesData = [
  {
    name: "Jennifer Markus",
    id: "01234",
    payable: "1,500.00",
    paid: "500.00",
    pending: "3,500.00",
    description: "Fees",
  },
  {
    name: "Jennifer Markus",
    id: "01234",
    payable: "4,500.00",
    paid: "5,500.00",
    pending: "6,500.00",
    description: "Fine",
  },
  {
    name: "Jennifer Markus",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Charges",
  },
];
export const feesData2 = [
  {
    name: "Mary Fruend",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Fees",
  },
  {
    name: "Mary Fruend",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Fine",
  },
  {
    name: "Mary Fruend",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Charges",
  },
];
export const feesData3 = [
  {
    name: "John Doe",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Fees",
  },
  {
    name: "John Doe",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Fine",
  },
  {
    name: "John Doe",
    id: "01234",
    payable: "4,500.00",
    paid: "2,500.00",
    pending: "2,500.00",
    description: "Charges",
  },
];
